import type { ClinicaPendencia } from "@/api/db/clinica";

export const ClinicaLabels = {
	pageTitle: "Clínica",
	pageDescription: "Pendências clínicas abertas.",
	summary(total: number) {
		if (total === 0) {
			return "Nenhuma pendência aberta.";
		}

		return `${total} pendência${total === 1 ? "" : "s"} aberta${total === 1 ? "" : "s"}.`;
	},
	allClear: {
		title: "Clínica em dia",
		description: "Nenhuma pendência clínica aberta.",
	},
	tile: {
		transcript_to_link(count: number) {
			return count === 1 ? "transcrição a vincular" : "transcrições a vincular";
		},
		exam_to_confirm(count: number) {
			return count === 1 ? "exame a confirmar" : "exames a confirmar";
		},
		exam_parked(count: number) {
			return count === 1 ? "exame sem dona" : "exames sem dona";
		},
		prontuario_to_review(count: number) {
			return count === 1 ? "prontuário a revisar" : "prontuários a revisar";
		},
		manual_to_finish(count: number) {
			return count === 1 ? "manual a terminar" : "manuais a terminar";
		},
	} satisfies Record<ClinicaPendencia["type"], (count: number) => string>,
};
